export default "__VITE_ASSET__DBgHzykV__"